import { Margins } from '../../utils/d3Utils.ts';


export const reportGraphMargins: Margins = { top: 50, right: 50, bottom: 40, left: 125 };
